import { useEffect } from "react";
import { Link } from "wouter";
import { scrollToTop } from "@/lib/utils";
import { services } from "@/lib/data";

export default function ServicesPage() {
  useEffect(() => {
    scrollToTop();
    
    // Handle anchor links
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          setTimeout(() => {
            const headerOffset = 100;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          }, 100);
        }
      }
    };
    
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
  
  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#1a365d] mb-4">Our Nationwide Accounting Services</h1>
          <div className="w-24 h-1 bg-[#7d9b76] mx-auto mb-6"></div>
          <p className="max-w-3xl mx-auto text-lg">
            Comprehensive financial solutions tailored to your business needs, available remotely across all 50 states. Discover how SW Accounting can help your business thrive with our expert virtual accounting services.
          </p>
          <div className="mt-8">
            <p className="font-semibold text-lg mb-2">Contact Us for a Free Consultation</p>
            <div className="flex flex-wrap justify-center gap-4 mt-4">
              <span className="bg-[#1a365d] text-white px-4 py-2 rounded-full">Law Firms</span>
              <span className="bg-[#1a365d] text-white px-4 py-2 rounded-full">Contractors</span>
              <span className="bg-[#1a365d] text-white px-4 py-2 rounded-full">Real Estate</span>
              <span className="bg-[#1a365d] text-white px-4 py-2 rounded-full">Manufacturing</span>
              <span className="bg-[#1a365d] text-white px-4 py-2 rounded-full">Technology</span>
              <span className="bg-[#1a365d] text-white px-4 py-2 rounded-full">Trusts & Investments</span>
              <span className="bg-[#1a365d] text-white px-4 py-2 rounded-full">Farm & Ranch</span>
            </div>
          </div>
        </div>
        
        <div className="mb-12">
          {services.map((service, index) => (
            <div 
              key={index} 
              id={service.id}
              className={`py-12 ${index % 2 === 0 ? 'bg-white' : 'bg-[#f8f9fa]'} rounded-lg mb-8`}
            >
              <div className="container mx-auto px-4">
                <div className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center`}>
                  <div className="lg:w-1/3 mb-8 lg:mb-0 flex justify-center">
                    <div className={`text-8xl text-[#7d9b76] flex items-center justify-center w-32 h-32 rounded-full ${index % 2 === 0 ? 'bg-[#f8f9fa]' : 'bg-white'}`}>
                      <i className={service.icon}></i>
                    </div>
                  </div>
                  <div className="lg:w-2/3 lg:px-8">
                    <h2 className="font-serif text-3xl font-bold text-[#1a365d] mb-4">{service.title}</h2>
                    <p className="text-lg mb-4">{service.description}</p>
                    <p className="mb-6">{service.longDescription}</p>
                    
                    <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-3">Key Benefits:</h3>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
                      {service.benefits.map((benefit, i) => (
                        <li key={i} className="flex items-start">
                          <div className="text-[#7d9b76] mr-2 mt-1"><i className="fas fa-check-circle"></i></div>
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                    
                    <Link href="/booking" className="inline-block bg-[#7d9b76] hover:bg-opacity-90 text-white font-bold py-3 px-6 rounded-md transition-all duration-300">
                      Get Started
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-[#1a365d] text-white p-8 rounded-lg">
          <div className="text-center mb-6">
            <h2 className="font-serif text-3xl font-bold mb-4">Ready to Transform Your Financial Management?</h2>
            <p className="max-w-3xl mx-auto">
              Whether you need comprehensive bookkeeping, payroll automation, or strategic financial guidance, SW Accounting has the expertise to help your business succeed regardless of location. Our virtual accounting services are available nationwide.
            </p>
          </div>
          <div className="flex justify-center">
            <Link href="/booking" className="bg-white text-[#1a365d] hover:bg-opacity-90 font-bold py-3 px-8 rounded-md transition-all duration-300 inline-block">
              Schedule a Consultation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
